import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";
import { AuthorizePaymentMutation } from "@/gql/graphql";
import { rebateProgressQuery } from "./UseRebateProgress";
import { rebateOverviewQuery } from "./UseRebateOverview";

const mutation = gql`
  mutation AuthorizePayment($goalId: ID!) {
    productPrice {
      rebate {
        authorizePayment(goalId: $goalId)
      }
    }
  }
`;

export const useAuthorizePayment = () => {
  const [mutate, { loading, error }] = useMutation<AuthorizePaymentMutation>(
    mutation,
    {
      refetchQueries: [rebateOverviewQuery, "rebateOverviewFetcher"],
    }
  );

  const authorizePayment = useCallback(
    (goalId: string) => {
      return mutate({ variables: { goalId } });
    },
    [mutate]
  );

  return {
    authorizePayment,
    loading,
    error,
  };
};
